import { useRef, useEffect } from 'react';

export const useDebounce = (callback, delay) => {
    const callbackRef = useRef(callback);
    const timeoutRef = useRef(null);

    // Update callback if it changes
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    function debounceFunction(...args) {
        // Clear the previous timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Set a new timeout
        timeoutRef.current = setTimeout(() => {
            callbackRef.current(...args);
        }, delay);
    }

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return debounceFunction;
}